import { useContext } from 'react';
import UserContext from '../components/UserContext';

const useLoginState = () => {
    const { user } = useContext(UserContext);
    return !!user;
};

export default useLoginState;
